import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTheme } from "../style/theme";

const Sorters = ({ selectedSort,
  onSortChange,
  isDescending,
  onDirectionChange }) => {
  const [anchorElSort, setAnchorElSort] = useState(null);
  const [anchorElDirection, setAnchorElDirection] = useState(null);
  // const [selectedSort, setSelectedSort] = useState("Name");
  // const [isDescending, setIsDescending] = useState(true);
  const { mode } = useTheme();

  const handleSortMenuOpen = (event) => {
    setAnchorElSort(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setAnchorElSort(null);
  };

  const handleDirectionMenuOpen = (event) => {
    setAnchorElDirection(event.currentTarget);
  };

  const handleDirectionMenuClose = () => {
    setAnchorElDirection(null);
  };

  const handleSortSelection = (option) => {
    onSortChange(option); // Call parent's handler
    handleSortMenuClose();
  };

  const handleToggleSortDirection = () => {
    onDirectionChange(prev => !prev); // Call parent's handler
    handleDirectionMenuClose();
  };

  return (
    <Box display="flex" gap={2}>
      {/* Sort Direction Button */}
      <Button
        variant="outlined"
        onClick={handleDirectionMenuOpen}
        sx={{
          height: 40,
          minWidth: 40,
          borderRadius: 6,
          // backgroundColor: "custom.search.main",
          color: "#757575",
          borderColor: "transparent",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 10px",
          "&:hover": {
            // backgroundColor: "custom.search.focus",

            borderColor: "transparent",
          },
        }}
      >
        {isDescending ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
      </Button>
      <Menu
        anchorEl={anchorElDirection}
        open={Boolean(anchorElDirection)}
        onClose={handleDirectionMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            minWidth: "220px",
            // backgroundColor: "rgb(3, 3, 3)", // Matches Sort By menu
            // color: "#fff", 
            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

          },
        }}
      >
        <MenuItem onClick={handleToggleSortDirection}>
          <ListItemIcon>{isDescending ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}</ListItemIcon>
          <ListItemText primary="Reverse Sort Direction" />
        </MenuItem>
      </Menu>

      {/* Sort Type Button */}
      <Button
        variant="outlined"
        onClick={handleSortMenuOpen}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          height: 40,
          minWidth: 120,
          borderRadius: 6,
          backgroundColor: "custom.search.main",
          color: "#757575",
          borderColor: "transparent",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px 16px",
          "&:hover": {
            backgroundColor: "custom.search.focus",
            borderColor: "transparent",
          },
        }}
      >
        {selectedSort}
      </Button>
      <Menu
        anchorEl={anchorElSort}
        open={Boolean(anchorElSort)}
        onClose={handleSortMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            minWidth: "300px",
            // backgroundColor: "rgb(3, 3, 3)",
            // color: "#fff",
            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

          },
        }}
      >
        <Typography sx={{ px: 2, py: 1, fontSize: "12px", color: "rgba(255, 255, 255, 0.6)", fontWeight: 500 }}>
          Sort By
        </Typography>
        {["Name", "Last Modified", "Last Modified by Me", "Last Opened by Me"].map((option) => (
          <MenuItem key={option} onClick={() => handleSortSelection(option)}>
            <ListItemIcon>
              {selectedSort === option && <ArrowDownwardIcon sx={{ fontSize: "18px", minWidth: 25 }} />}
            </ListItemIcon>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Menu>

      {/* More Options Button */}
      <IconButton sx={{
        color: "#757575",
        padding: "4px",
        height: 40,
        minWidth: 40,
      }}>
        <MoreVertIcon />
      </IconButton>
    </Box>
  );
};

export default Sorters;
